import { get } from 'lodash';

export const getBoundariesByFieldUuid = (state, fieldUuid) => {
  return state.boundaries[fieldUuid] && state.boundaries[fieldUuid].boundary;
};
export const getCentroidCoordinatesByFieldUuid = (state, fieldUuid) => {
  const centroid = state.boundaries[fieldUuid] && state.boundaries[fieldUuid].centroid;
  return get(centroid, 'coordinates');
};
